import { useEffect } from "react"
import Header from "../../components/header/header"
import Footer from "../../components/footer/footer"
import MeetKate from "./components/meet-kate/meet-kate"
import BuildProfile from "./components/build-profile/build-profile"
import FindWork from "./components/find-work/find-work"
import TalentsHowItWorks from "./components/how-it-works/how-it-works"
import Hero from "./components/hero/hero"
import PricingPlans from "./components/pricing-plans/pricing-plans"
import pageShell from "../../shared/pageShell.module.css"
import startupsLandingStyles from "../../components/startups-landing/startups-landing-sections.module.css"
import styles from "./talents-page.module.css"

const TalentsPage = () => {
	useEffect(() => {
		document.title = "Talents - Techcore"
	}, [])

	return (
		<div className={`${pageShell.page} ${styles.talents}`}>
			<Header talents />
			<Hero />

			<div className={startupsLandingStyles.startupsLandingRoot}>
				<TalentsHowItWorks />
				<BuildProfile />
				<FindWork />
				<MeetKate />
				<PricingPlans />
			</div>

			<Footer />
		</div>
	)
}

export default TalentsPage
